




















import { isArray } from "lodash"
import { Component, Vue, Prop } from "vue-property-decorator"
import { mapState } from "vuex"

interface RawFormOption {
  key: string;
  value: string | boolean | number | [];
}

interface BodySystem {
  key: string;
  value: string;
}

@Component({
  computed: {
    ...mapState("BodySystem", {
      bodySystems: "bodySystems",
    }),
  },
})
export default class QuestionRawFormOption extends Vue {
  @Prop() readonly item!: RawFormOption

  bodySystems!: BodySystem[]

  get localItemValue() {
    if (
      this.item.key == "filter_by_body_systems" &&
      this.item.value &&
      !isArray(this.item.value)
    ) {
      const values = (this.item.value as string).split(",")

      return this.bodySystems.filter(bs => values.includes(bs.key))
    }

    return this.item.value
  }

  set localItemValue(v) {
    if (this.item.key == "filter_by_body_systems" && isArray(v)) {
      v = v.map(val => val.key).join(",")
    }
    
    this.$emit("update:item", {
      key: this.item.key,
      value: v
    })
  }

  get whiteList() {
    return {
      is_required: {
        label: "Candidate must answer this question?",
        component: "v-switch",
      },
      is_multiple: {
        label: "Allow candidate select multiple options?",
        component: "v-switch",
      },
      range: {
        label: "Is range date picker?",
        component: "v-switch",
      },
      min: {
        label: "Minimum number",
        component: "v-text-field",
        type: "number",
      },
      max: {
        label: "Maximum number",
        component: "v-text-field",
        type: "number",
      },
      step: {
        label: "Step",
        component: "v-text-field",
        type: "number",
      },
      min_date: {
        label: "Minimum date",
        component: "v-text-field",
        hint: "Please specify the minimum date in yyyy-mm-dd format, or use 'now' to represent that the end user can only select a date in the future",
      },
      max_date: {
        label: "Maximum date",
        component: "v-text-field",
        hint: "Please specify the maximum date in yyyy-mm-dd format, or use 'now' to represent that the end user can only select a date in the past",
      },
      date_format: {
        label: "Date format",
        component: "v-combobox",
        items: ["mm/yy", "dd/mm/yy"],
        hint: "Available formats: dd/mm/yy, mm/yy",
      },
      filter_by_body_systems: {
        label: "Filter body part options by selected body systems below",
        items: this.bodySystems,
        component: "v-combobox",
        itemText: "display_name",
        itemValue: "key",
        returnObject: true,
        multiple: true,
      },
    }
  }

  isBoolean(v) {
    return v === "true" || v === "false" || v === true || v === false
  }
}
